import { render } from "./DobleCarret.vue?vue&type=template&id=11b7533f"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/DobleCarret.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11b7533f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11b7533f', __exports__)) {
    api.reload('11b7533f', __exports__)
  }
  
  module.hot.accept("./DobleCarret.vue?vue&type=template&id=11b7533f", () => {
    api.rerender('11b7533f', render)
  })

}


export default __exports__